module.exports = __webpack_public_path__ + "img/user-1.30e1978f.jpg";